import { SimpleOrgMember } from '@euler/model/SimpleOrgMember';
import { StoreService } from '@euler/services/store.service';

const kMembers: SimpleOrgMember[] = [
  { id: 1, name: '王店长', role: 'manager', jobTitle: '店长' },
  { id: 12, name: '李主管', role: 'serviceAgent', jobTitle: '服务顾问' },
  { id: 13, name: '张技师', role: 'technician', jobTitle: '技师' },
  { id: 14, name: '陈前台', role: 'serviceAgent', jobTitle: '前台' },
  { id: 15, name: '刘技师', role: 'technician', jobTitle: '技师' },
];

/** The store's members for the sharing panel, without a server. */
export class FixtureStoreService extends StoreService {
  constructor() {
    super(null as never);
  }
  async getSimpleMemberList(): Promise<SimpleOrgMember[]> {
    return kMembers;
  }
}
